import React, { useState } from "react";
import { Stamp } from "lucide-react";
import GestionaleShell from "./GestionaleShell";
import GestCrudTable from "./GestCrudTable";

const FIELDS = [
  { key: "container_code", label: "Container", type: "text", placeholder: "es. AMZ-2026-001" },
  { key: "dossier_no", label: "N° Dossier", type: "text" },
  { key: "li_no", label: "LI Brasil", type: "text" },
  { key: "siscomex_no", label: "SISCOMEX", type: "text", hideInTable: true },
  { key: "broker", label: "Broker", type: "select", options: [
    { value: "ADDUMA", label: "ADDUMA" }, { value: "DTA", label: "DTA Brasil" }, { value: "OTHER", label: "Altro" },
  ], defaultValue: "ADDUMA" },
  { key: "submitted_at", label: "Sottomesso il", type: "date", hideInTable: true },
  { key: "expected_release", label: "Release prevista", type: "date" },
  { key: "status", label: "Stato MAPA", type: "select", statusTone: true, options: [
    { value: "dossier_prep", label: "Preparazione", tone: "stone" },
    { value: "broker_review", label: "Broker review", tone: "blue" },
    { value: "li_submitted", label: "LI inviata", tone: "blue" },
    { value: "mapa_analysis", label: "MAPA analisi", tone: "amber" },
    { value: "exigencia", label: "Exigência", tone: "rose" },
    { value: "approved", label: "Approvato", tone: "emerald" },
    { value: "released", label: "Rilasciato", tone: "emerald" },
  ], defaultValue: "dossier_prep" },
  { key: "exigencia_notes", label: "Exigência (note)", type: "textarea", hideInTable: true },
  { key: "notes", label: "Note interne", type: "textarea", hideInTable: true },
];

export default function MapaCasesPage() {
  const [data, setData] = useState({ total: 0, items: [] });
  const open = (data.items || []).filter(i => !["approved", "released"].includes(i.status)).length;

  return (
    <GestionaleShell
      icon={Stamp}
      code="05"
      title="MAPA Workflow"
      subtitle="Compliance importazione Brasile: dossier LI / SISCOMEX, broker review, exigências e release."
      kpiBlocks={[
        { value: data.total || 0, label: "Pratiche totali" },
        { value: open, label: "Aperte" },
      ]}
    >
      <GestCrudTable
        endpoint="/gestionale/mapa-cases"
        fields={FIELDS}
        itemLabel="pratica MAPA"
        emptyHint="Crea il primo dossier MAPA collegato a un container per attivare il workflow."
        testIdPrefix="mapa"
        onItemsLoaded={(d) => setData(d)}
      />
    </GestionaleShell>
  );
}
